import React from "react";
import { useTranslation } from 'react-i18next';

// core components
import { Button, Typography } from "stories/components"
import { Card, CardBody, CardHeader, Col, Container, Row } from "stories/layout"

const Login = () => {

  const { t } = useTranslation();
  
  return (
    <>
      <Container className="mt-8 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7" className="">
            <Card variant="primary">
              <CardHeader className="bg-transparent pt-5 pb-1">
                
                <div className="text-center text-muted mb-2">
                  <Typography variant="h2" className="mb-2">{t('Virhe kirjautumisessa')}</Typography>
                  <Typography variant="p">{t('Palvelun käyttö vaatii kolmannen osapuolen evästeiden sallimisen')}</Typography>
                </div>
                
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-5">
                <Row className="mb-0">
                  <Col className="xs-12 text-center">
                    {t('Salli evästeet Google Chrome selaimella')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="xs-12 text-center">
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank">https://support.google.com/chrome/answer/95647</a>
                  </Col>
                </Row>
                
                <Row className="mb-0">
                  <Col className="xs-12 text-center">
                    {t('Salli evästeet Safari selaimella')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="xs-12 text-center">
                    <a href="https://support.apple.com/fi-fi/guide/safari/sfri11471/mac" target="_blank">https://support.apple.com/fi-fi/guide/safari/sfri11471/mac</a>
                  </Col>
                </Row>
                
                <div className="text-center text-muted mb-4">
                  <Button className="my-4" color="primary" type="button">
                    {t('Kirjaudu uudelleen sisään')} (not implemented)
                  </Button>
                </div>
                
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;
